import UnfoldLess from '@mui/icons-material/UnfoldLess';
import UnfoldMore from '@mui/icons-material/UnfoldMore';
import IconButton, { iconButtonClasses } from '@mui/material/IconButton';
import { useCallback } from 'react';

import { NEW_DISPATCH_TOPBAR_CONTROLS_HEIGHT_IN_PX } from '~constants/filters';

export enum ExpandedState {
  COLLAPSED = 'collapsed',
  EXPANDED = 'expanded',
}

interface ExpandedStateButtonProps {
  onChange: (state: `${ExpandedState}`) => void;
  state: `${ExpandedState}`;
}

export default function ExpandedStateButton({
  onChange,
  state,
}: ExpandedStateButtonProps) {
  const handleChange = useCallback(() => {
    const newState =
      state === ExpandedState.COLLAPSED
        ? ExpandedState.EXPANDED
        : ExpandedState.COLLAPSED;

    onChange(newState);
  }, [state, onChange]);

  return (
    <IconButton
      onClick={handleChange}
      size="small"
      sx={(theme) => ({
        [`&.${iconButtonClasses.root}`]: {
          border: `solid 1px ${theme.brandV2.colors.treadGray7}`,
          borderRadius: theme.spacing(0.5),
          color: theme.brandV2.colors.treadBlack,
          height: `${NEW_DISPATCH_TOPBAR_CONTROLS_HEIGHT_IN_PX}px`,
          p: '2px',
          width: `${NEW_DISPATCH_TOPBAR_CONTROLS_HEIGHT_IN_PX}px`,
        },
      })}
    >
      {state === ExpandedState.EXPANDED ? (
        <UnfoldLess sx={{ fontSize: '18px' }} />
      ) : (
        <UnfoldMore sx={{ fontSize: '18px' }} />
      )}
    </IconButton>
  );
}
